<div class="mi">
  <div class="mi-head">
    <div class="mi-head-text">
      <h2 class="mi-title">Share this map</h2>
      <div class="mi-sub">
        People you add can edit this map and its wiki, and can invite or remove others too.
        You're the owner, so you always keep access.
      </div>
    </div>
    <button type="button" class="mi-close" (click)="closemodel()" aria-label="Close" [disabled]="loading">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
    </button>
  </div>

  @if (isFetching) {
    <div class="mi-loading" role="status">
      <span class="mi-spinner" aria-hidden="true"></span>
      Loading who has access…
    </div>
  } @else {
    <div class="mi-body">
      <div class="mi-slots">
        <span class="mi-slots-text">
          <strong>{{ slotsUsed }}</strong> of {{ slotsTotal }} spots used
        </span>
        <span class="mi-meter" aria-hidden="true"><span [style.width.%]="slotsTotal ? (slotsUsed / slotsTotal) * 100 : 0"></span></span>
      </div>

      <!-- people already invited -->
      <div class="mi-label">People with access</div>
      @if (hasExisting) {
        <ul class="mi-list">
          @for (row of emailRows; track row; let i = $index) {
            @if (row.isExisting) {
              <li class="mi-person">
                <span class="mi-avatar" aria-hidden="true">{{ (row.email || '?').charAt(0).toUpperCase() }}</span>
                <span class="mi-email">{{ row.email }}</span>
                <span class="mi-status"
                  [class.is-accepted]="row.status === 'ACCEPTED'"
                  [class.is-pending]="row.status === 'PENDING'"
                  [class.is-declined]="row.status === 'REJECTED'">
                  {{ row.status === 'ACCEPTED' ? 'Has access' : row.status === 'PENDING' ? 'Invite sent' : 'Declined' }}
                </span>
                @if (row.status === 'PENDING') {
                  <button type="button" class="mi-icon-btn" (click)="deleteRow(i)"
                    title="Cancel this invitation" [attr.aria-label]="'Cancel the invitation for ' + row.email">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
                  </button>
                } @else {
                  <span class="mi-icon-spacer" aria-hidden="true"></span>
                }
              </li>
            }
          }
        </ul>
      } @else {
        <div class="mi-empty">Nobody yet. Invite someone below.</div>
      }

      <!-- new invitations -->
      @if (newRowCount > 0) {
        <div class="mi-label">Invite people</div>
        <div class="mi-new-list">
          @for (row of emailRows; track row; let i = $index) {
            @if (!row.isExisting) {
              <div class="mi-new">
                <input type="email" class="mi-input" [id]="'email' + i" placeholder="name@example.com"
                  autocomplete="email" (change)="onInputchng($event, i)" [(ngModel)]="row.email"
                  [ngModelOptions]="{ standalone: true }" aria-label="Email address to invite" />
                @if (newRowCount > 1) {
                  <button type="button" class="mi-icon-btn" (click)="deleteRow(i)" title="Remove this row" aria-label="Remove this row">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
                  </button>
                } @else {
                  <span class="mi-icon-spacer" aria-hidden="true"></span>
                }
              </div>
            }
          }
        </div>
      }

      @if (emailalert) {
        <div class="mi-error" role="alert">{{ emailalert }}</div>
      }

      @if (emailRows?.length < 5) {
        <button type="button" class="mi-add" (click)="addRow(emailRows.length)">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
          {{ newRowCount > 0 ? 'Add another person' : 'Invite someone' }}
        </button>
      } @else {
        <div class="mi-hint">All {{ slotsTotal }} spots are in use. Cancel a pending invitation to free one up.</div>
      }
    </div>
  }

  <div class="mi-actions">
    <button type="button" class="btn btn-dark" (click)="closemodel()" [disabled]="loading">Cancel</button>
    <button type="button" class="btn btn-theme" (click)="sendEmail()" [disabled]="loading || isFetching || !anyAddedRow()">
      {{ loading ? 'Sending…' : 'Send invitations' }}
    </button>
  </div>
</div>
